<template>
  <router-link
    :to="{ name: routeName }"
    class="account-menu"
    :class="{ 'account-menu--active': $route.name === routeName }"
    @click="clicked"
  >
    <span class="account-menu__content">
      <span class="account-menu__icon">
        <svg
          v-if="title === 'Personal Information'"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 9C11.0711 9 12.75 7.32107 12.75 5.25C12.75 3.17893 11.0711 1.5 9 1.5C6.92893 1.5 5.25 3.17893 5.25 5.25C5.25 7.32107 6.92893 9 9 9Z"
            fill="currentColor"
          />
          <path
            opacity="0.4"
            d="M9 10.875C5.4975 10.875 2.625 13.2075 2.625 16.125C2.625 16.3325 2.7925 16.5 3 16.5H15C15.2075 16.5 15.375 16.3325 15.375 16.125C15.375 13.2075 12.5025 10.875 9 10.875Z"
            fill="currentColor"
          />
        </svg>
        <svg
          v-else-if="title === 'KYC Documents'"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 4.5C3 3.67157 3.67157 3 4.5 3H10.5L15 7.5V13.5C15 14.3284 14.3284 15 13.5 15H4.5C3.67157 15 3 14.3284 3 13.5V4.5Z"
            stroke="currentColor"
            stroke-width="1.5"
            fill="none"
          />
          <path d="M10.5 3V7.5H15" stroke="currentColor" stroke-width="1.5" fill="none"/>
          <path d="M6 10.5H12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          <path d="M6 12.75H9.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
        <svg
          v-else-if="title === 'Bank Information'"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M2.25 15H15.75V16.5H2.25V15Z" fill="currentColor"/>
          <path d="M3 9H4.5V14.25H3V9Z" fill="currentColor"/>
          <path d="M6.75 9H8.25V14.25H6.75V9Z" fill="currentColor"/>
          <path d="M9.75 9H11.25V14.25H9.75V9Z" fill="currentColor"/>
          <path d="M13.5 9H15V14.25H13.5V9Z" fill="currentColor"/>
          <path d="M2.25 5.25L9 1.5L15.75 5.25V8.25H2.25V5.25Z" fill="currentColor" opacity="0.4"/>
          <circle cx="9" cy="5.25" r="1.125" fill="currentColor"/>
        </svg>
        <svg
          v-else-if="title === 'Security'"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.5 6.75H14.25C14.6642 6.75 15 7.08579 15 7.5V15C15 15.4142 14.6642 15.75 14.25 15.75H3.75C3.33579 15.75 3 15.4142 3 15V7.5C3 7.08579 3.33579 6.75 3.75 6.75H4.5V6C4.5 3.51472 6.51472 1.5 9 1.5C11.4853 1.5 13.5 3.51472 13.5 6V6.75Z"
            stroke="currentColor"
            stroke-width="1.5"
            fill="none"
          />
          <path d="M6 6.75V6C6 4.34315 7.34315 3 9 3C10.6569 3 12 4.34315 12 6V6.75" stroke="currentColor" stroke-width="1.5"/>
          <circle cx="9" cy="11.25" r="1.5" fill="currentColor"/>
        </svg>
        <svg
          v-else-if="title === 'Subscription Plans'"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
            stroke="currentColor"
            stroke-width="1.5"
            fill="none"
          />
          <path d="M9 4.5V9L12 10.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
        <svg
          v-else-if="title === 'Configurations'"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M2.25 13.5H5.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          <path d="M8.25 13.5H15.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          <circle cx="6.75" cy="13.5" r="1.5" stroke="currentColor" stroke-width="1.5" fill="none"/>
          <path d="M2.25 9H9.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          <path d="M12.75 9H15.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          <circle cx="11.25" cy="9" r="1.5" stroke="currentColor" stroke-width="1.5" fill="none"/>
          <path d="M2.25 4.5H5.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          <path d="M8.25 4.5H15.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          <circle cx="6.75" cy="4.5" r="1.5" stroke="currentColor" stroke-width="1.5" fill="none"/>
        </svg>
        <svg
          v-else-if="title === 'Live Chat'"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 13.5H13.6778L15 14.5388V6.75H15.75C16.1642 6.75 16.5 7.08579 16.5 7.5V17.625L13.1588 15H6.75C6.33579 15 6 14.6642 6 14.25V13.5Z"
            fill="currentColor"
            opacity="0.4"
          />
          <path
            d="M4.09125 12L1.5 14.625V3C1.5 2.58579 1.83579 2.25 2.25 2.25H12.75C13.1642 2.25 13.5 2.58579 13.5 3V12H4.09125Z"
            stroke="currentColor"
            stroke-width="1.5"
            fill="none"
          />
        </svg>
      </span>
      <span class="account-menu__label">{{ title }}</span>
    </span>
    <svg
      class="account-menu__arrow"
      width="6"
      height="10"
      viewBox="0 0 6 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1L5 5L1 9"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </router-link>
</template>

<script>
  export default {
    name: "AccountMenu",
    props: {
      title: {
        type: String,
        required: true,
        default: () => "",
      },
      routeName: {
        type: String,
        required: false,
      },
      focus: { type: Boolean, default: () => false },
    },
    emits: ["clicked"],
    methods: {
      clicked() {
        this.$emit("clicked", this.title);
      },
    },
  };
</script>

<style lang="scss" scoped>
.account-menu {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  border-radius: 10px;
  color: #64748B;
  text-decoration: none;
  transition: all 0.15s ease;
  margin-bottom: 4px;

  &:hover {
    background-color: #F8FAFC;
    color: #475569;
  }

  &--active {
    background-color: #F1F5F9;
    color: #001240;

    .account-menu__arrow {
      opacity: 1;
    }
  }

  &__content {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    flex-shrink: 0;

    svg {
      width: 18px;
      height: 18px;
    }
  }

  &__label {
    font-size: 14px;
    font-weight: 500;
  }

  &__arrow {
    opacity: 0;
    transition: opacity 0.15s ease;

    @media (max-width: 767px) {
      display: none;
    }
  }
}
</style>
